import React, { useMemo } from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import {
	atLeastEightChars,
	atLeastOneLower,
	atLeastOneNumberOrSymbol,
	atLeastOneUpper,
} from '../../utils/steps-utils';

import './password-validator-helper-tooltip.less';

const PasswordRule = ({ label, isChecked }) => (
	<div className="password-rule">
		{isChecked ? (
			<i className="rule-icon fa fa-check-circle" />
		) : (
			<i className="rule-icon fa fa-circle-thin" />
		)}
		<span className="rule-label">{label}</span>
	</div>
);

const PasswordValidatorHelperTooltip = ({ showPasswordTooltip, password, children }) => {
	const tooltipText = useMemo(
		() => (
			<div className="password-validation">
				<PasswordRule label="At least 8 characters" isChecked={atLeastEightChars(password)} />
				<PasswordRule label="One lowercase letter" isChecked={atLeastOneLower(password)} />
				<PasswordRule label="One uppercase letter" isChecked={atLeastOneUpper(password)} />
				<PasswordRule label="One number or symbol" isChecked={atLeastOneNumberOrSymbol(password)} />
			</div>
		),
		[password],
	);

	return (
		<Tooltip
			title={showPasswordTooltip ? tooltipText : ''}
			arrow={true}
			disableHoverListener
			enterDelay={1000}
		>
			{children}
		</Tooltip>
	);
};

export default PasswordValidatorHelperTooltip;
